export default __webpack_public_path__ + "static/media/default-image.0a719764.svg";